import { Palette } from '@material-ui/core/styles/createPalette'
import { Overrides as CoreOverrides } from '@material-ui/core/styles/overrides'
import {
  PaginationClassKey,
  PaginationItemClassKey,
  AutocompleteClassKey
} from '@material-ui/lab'
import { CSSProperties } from '@material-ui/styles'

interface Overrides extends CoreOverrides {
  MuiPagination?:
    | Partial<Record<PaginationClassKey, CSSProperties | (() => CSSProperties)>>
    | undefined
  MuiPaginationItem?:
    | Partial<
        Record<PaginationItemClassKey, CSSProperties | (() => CSSProperties)>
      >
    | undefined
  MuiAutocomplete?:
    | Partial<
        Record<AutocompleteClassKey, CSSProperties | (() => CSSProperties)>
      >
    | undefined
}

const generateOverrides = (palette: Palette): Overrides => {
  return {
    MuiCssBaseline: {
      '@global': {
        'body, #root': {
          height: '100%',
          margin: 0
        },
        body: {
          overflow: 'overlay',
          overflowX: 'hidden'
        }
        // img: {
        //   // width: '100%',
        //   height: '100%'
        // },
        // a: {
        //   fontSize: 16,
        //   textDecoration: 'none'
        // },
        // ul: {
        //   margin: '5px 0',
        //   fontSize: '16px',
        //   lineHeight: '26px',
        //   padding: '0 20px'
        // },
        // ol: {
        //   margin: '5px 0'
        // }
      }
    },

    // Button
    MuiButton: {
      root: {
        minHeight: 40,
        padding: '10px 20px',
        fontSize: 16,
        lineHeight: 1.25,
        fontWeight: 500,
        textTransform: 'initial',
        borderRadius: 6
      },

      sizeSmall: {
        minHeight: 32,
        padding: '8px 15px',
        fontSize: 14,
        fontWeight: 500
      },

      sizeLarge: {
        padding: '14px 30px'
      },

      outlinedPrimary: {
        backgroundColor: palette.primary.light
      },

      outlinedSizeSmall: {
        backgroundColor: palette.secondary.main,
        border: `1px solid ${palette.grey[200]}`
      }
    },

    // Input
    MuiInputBase: {
      input: {
        background: palette.common.white,

        '&::placeholder': {
          opacity: 1
        }
      }
    },

    MuiInputLabel: {
      outlined: {
        transform: 'translate(14px, 16px) scale(1)'
      }
    },

    MuiOutlinedInput: {
      root: {
        borderRadius: 6
      },
      input: {
        padding: '14.5px 14px'
      }
    },

    // Card
    MuiCard: {
      root: {
        boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.03)',
        border: `1px solid ${palette.grey[200]}`,
        borderRadius: 10
      }
    },

    // CardContent
    MuiCardContent: {
      root: {
        padding: 30,

        '&:last-child': {
          paddingBottom: 30
        }
      }
    },

    // Chip
    MuiChip: {
      root: {
        height: 36,
        fontSize: 14,
        fontWeight: 600,
        borderRadius: 6
      }
    },

    // Select
    MuiSelect: {
      outlined: {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    // CheckBox
    MuiCheckbox: {
      root: {
        color: palette.grey[300]
      }
    },

    // FormControlLabel
    MuiFormControlLabel: {
      root: {
        marginRight: 0
      }
    },

    // Autocomplete
    MuiAutocomplete: {
      inputRoot: {
        padding: '5px !important',
        backgroundColor: palette.common.white
      }
    },

    // Pagination
    MuiPagination: {
      root: {
        display: 'flex',
        justifyContent: 'center'
      },

      ul: {
        border: `1px solid ${palette.text.disabled}`,
        borderRadius: 4,
        overflow: 'hidden',

        '& li:not(:last-child)': {
          borderRight: `1px solid ${palette.text.disabled}`
        }
      }
    },

    MuiPaginationItem: {
      root: {
        height: 42,
        minWidth: 45,
        margin: 0,
        borderRadius: 'inherit'
      },

      ellipsis: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 42
      }
    },

    // Dialog
    MuiDialogTitle: {
      root: {
        padding: '20px 25px 10px'
      }
    },

    MuiDialogContent: {
      root: {
        padding: '10px 25px 20px',
        overflowX: 'hidden'
      }
    }
  }
}

export default generateOverrides
